export default __webpack_public_path__ + "static/media/Img0029.ad22d7b9.png";